import axios from 'axios';
import CryptoJS from 'crypto-js'
import store from './index'
export const HTTP = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
        Authorization: localStorage.getItem('access_token')
    }
})


function getEncryptedPassword(usercredentials) {

    let key = CryptoJS.enc.Utf8.parse('4512631236589784');
    let iv = CryptoJS.enc.Utf8.parse('4512631236589784');

    let pwd = JSON.parse(JSON.stringify(usercredentials.password));

    var encrypted = CryptoJS.AES.encrypt(pwd, key, {
        iv: iv
    });
    usercredentials.password = encrypted.toString();
    return JSON.parse(JSON.stringify(usercredentials));

}

export const initializeInterceptor = () => {
    HTTP.interceptors.request.use(function (config) {
        if (config.url.includes('api/Book/search?query')) {
            return config;
        }
        store.commit('DISPLAY_LOADER', true);
        return config;
    }, function (error) {
        return Promise.reject(error)
    })

    // Add a response interceptor
    HTTP.interceptors.response.use(function (response) {
        // Do something with response data
        store.commit('DISPLAY_LOADER', false);
        if (response.data && response.data.message != '' && response.data.message != null) {
            store.commit('SHOW_SNACKBAR', { message: response.data.message, status: (response.data.status == 200) })
        }
        return response;

    }, function (error) {
        // Do something with response error
        return Promise.reject(error);
    });

}

export const userLogin = async ({ commit }, credentitals) => {
    credentitals = getEncryptedPassword(credentitals);
    await HTTP.post(`api/Authentication/Authentication`, credentitals).then((response) => {
        if (response.data.data.token) {
            const token = response.data.data.token
            axios.defaults.headers.common["Authorization"] =
                "Bearer " + token;
            HTTP.headers = { Authorization: "Bearer " + token }
            localStorage.setItem("access_token", "Bearer " + token);
            localStorage.setItem("SID", response.data.data.userId);
            localStorage.setItem("sisUserId", response.data.data.sisUserId);
            localStorage.setItem("username", response.data.data.username);
            localStorage.setItem("isDepartmentChair", response.data.data.isDepartmentChair);
            localStorage.setItem("loggedIn", true);
            commit('USER_LOGIN');
        }
    })
}

export const logout = ({ commit }) => {
    localStorage.clear();
    commit("USER_LOGOUT")
    store.commit('SHOW_SNACKBAR', { message: 'Successfully Logged Out', status: true })
}

export const getPresentAndFutureTerms = ({ commit }) => {
    commit('VOID')
    return HTTP.get('Term/present-future-terms');
}

export const getTerms = async ({ commit }) => {
    await HTTP.get('Term').then((res) => {
        commit('GET_TERMS', res);
    })
}

export const getAllTerms = ({ commit }) => {
    commit('VOID');
    return HTTP.get('Term');
}

export const getTermsFaculty = async ({ commit }) => {
    commit('VOID');
    return await HTTP.get('Term');
}

export const previousTerms = ({ commit }, courseNumber) => {
    // commit('GET_PREVIOUSTERMS', res);
    commit('VOID');
    return HTTP.get(`Term/previous-terms?courseNumber=${courseNumber}`);

}
export const getPreviousTermsForTermId = ({ commit }, { courseNumber, selectedTermId }) => {
    commit('VOID');

    let url = `Term/previous-terms?courseNumber=${courseNumber}`;
    if (selectedTermId) {
        url += `&termId=${selectedTermId}`;
    }
    return HTTP.get(url);
};

export const updateAdoptionsByCSV = ({ commit }, formData) => {
    commit('VOID');
    // console.log(file);
    return HTTP.post('/api/Adoption/GetAdoptionByCSV', formData)
}

export const usePreviousBook = async ({ commit }, bookDetails) => {
    await HTTP.post('/api/Adoption/upsert-adoption', bookDetails)
    commit('VOID')

}

export const getDepartments = ({ commit }, termDetails) => {
    HTTP.get(`Department/departments/${termDetails.termId}`).then((res) => {
        commit('GET_DEPTS', { res: res, index: termDetails.index });
    })
}

export const getAllDepartments = ({ commit }, termDetails) => {
    commit('VOID');
    return HTTP.get(`Department/departments/${termDetails.termId}`);
}

export const getCourses = ({ commit }, deptDetails) => {
    HTTP.get(`Department/department/${deptDetails.departmentId}/${deptDetails.termId}/courses`).then((res) => {
        commit('GET_COURSES', { res: res, index: deptDetails.index });
    })
}

export const addCourseMaterial = ({ commit }) => {
    let courseMaterial = {
        termId: null,
        departmentId: null,
        courseId: null,
        sectionId: null,
        courses: [],
        sections: []
    }
    commit('ADD_COURSE_MATERIAL', courseMaterial);
}
export const addNewAuthor = ({ commit }) => {
    let author = { Name: null }
    commit('ADD_NEW_AUTHOR', author);
}

export const getSections = ({ commit }, courseDetails) => {
    commit('UPDATE_SECTIONS', courseDetails)
}

export const getAdoptions = async ({ commit }, sections) => {
    await HTTP.post('api/Adoption/GetAdoptionBySections', sections).then((res) => {
        commit('GET_ADOPTIONS', res);

    })
}

export const getSectionDetailsbyId = ({ commit }, sectionId) => {
    commit('VOID')
    return HTTP.get(`/Sections/section-details?id=${sectionId}`)

}
export const getAdoptionsbysections = ({ commit }, sectionIds) => {
    commit('VOID');
    return HTTP.post('api/Adoption/GetAdoptionBySections', sectionIds)
}
export const getAdoptionsByTerm = ({ commit }, terms) => {
    commit('VOID');
    return HTTP.post('api/Adoption/get-adoptions-course', terms)
}
export const getAdoptionsByTermCourse = ({ commit }, terms) => {
    commit('VOID');
    return HTTP.post('api/Adoption/get-adoptions-course', terms)
}
export const getCoursesByDept = ({ commit }, deptId) => {
    commit('VOID');
    return HTTP.get(`Term/previous-course-by-dept?deptCode=${deptId}`)
}
export const getTermsByCourses = ({ commit }, courseNo) => {
    commit('VOID');
    return HTTP.get(`Term/previous-terms-by-course?CourseNumber=${courseNo}`)
}

export const getAdoptionsofInstructor = ({ commit }, instructors) => {
    commit('VOID');
    console.log("getAdoptionsofInstructor", instructors)
    return HTTP.post('api/Adoption/adoptedbooks', instructors);
}

export const saveBookAdoption = async ({ commit }, bookDetails) => {
    commit('VOID');
    return await HTTP.post('api/Adoption/SaveAdoption', bookDetails);

}

export const removeAdoption = async ({ commit }, adoptionId) => {
    await HTTP.delete(`api/Adoption/delete-adoption/${adoptionId}`)
    commit('VOID');
}

export const removeAdoptionbySection = ({ commit }, sectiondelete) => {
    commit('VOID');
    return HTTP.post('api/Adoption/delete-adoptions-section', sectiondelete)
}

export const updateAdditonalMaterials =({commit},material)=>{
    commit('VOID');
    return HTTP.post('api/Adoption/update-suggestedMaterials', material)
}



export const getSearchResults = async ({ commit }, input) => {
    await HTTP.get(`api/Book/search?query=${input}&count=10`).then((res) => {
        commit('GET_SEARCHRESULTS', res);

    })
}

export const upsertAdoption =  ({ commit }, adoption) => {
    
      commit('VOID');
      return HTTP.post('api/Adoption/upsert-adoption', adoption);
  };

export const addFromPreviousAdoptions = ({ commit }, adoption) => {
    commit('VOID');
    return HTTP.post('api/Adoption/add-books-previous-adoptions', adoption)
}


export const saveSections = ({ commit }, sections) => {
    commit('SAVE_SECTIONS_SELECTION', sections)
}

export const showToaster = ({ commit }, messageConfig) => {
    commit('SHOW_SNACKBAR', { message: messageConfig.message, status: messageConfig.status })
}

export const getAdminDepartments = ({ commit }, index) => {
    commit('VOID');
    return HTTP.get(`Department/getdepartments/${index.sisUserId}/${index.termId}`)
}

export const getAdminCoursesByDepartment = ({ commit }, index) => {
    commit('VOID');
    return HTTP.get(`Department/department/${index.departmentId}/${index.termId}/courses`)
}

export const getAdoptionsByAdmin = async ({ commit }, data) => {

    commit('VOID');
    //  console.log('called');
    //  await HTTP.post('api/Adoption/adminAdoptedbooks', data).then((res) => {
    //      commit('UPDATE_NOTES_VARIABLE', res);
    //      console.log("in adoptions by admin action file")
    //      console.log(res);
    //      return res;
    //  })

    return HTTP.post('api/Adoption/adminAdoptedbooks', data);


}
export const getPages = ({ commit }, data) => {
    commit('VOID');
    return HTTP.post('api/Adoption/getAdoptedBookPages', data)
}

export const saveNote = ({ commit }, data) => {
    commit('VOID');
    const params = new URLSearchParams();

    if (data.note !== undefined && data.note !== null) {
        params.append('note', data.note);
    } else {
        params.append('note', "");
    }

    params.append('sectionId', data.sectionId);

    console.log(params.toString());
    console.log("params", params);
    console.log("data.note", data.note);

    //const url = `api/Adoption/Note?${params.toString()}`;
    //const url = `api/Adoption/Note?${data.note}`;
    //return HTTP.post(encodeURI(url));
    return HTTP.post('api/Adoption/Note', data);
}

export const getNote = ({ commit }, data) => {
    commit('VOID');
    const params = new URLSearchParams({
        sectionId: data.sectionId
    });
    return HTTP.get('api/Adoption/getNotes' + '?' + params.toString())
}
